import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";

export { toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isMobile = useIsMobile();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      closeButton
      duration={isMobile ? 2400 : 3500}
      visibleToasts={isMobile ? 2 : 3}
      offset={isMobile ? 14 : 24}
      swipeDirections={["top", "bottom"]}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background/95 group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-2xl group-[.toaster]:!rounded-2xl group-[.toaster]:backdrop-blur-md group-[.toaster]:px-4 group-[.toaster]:py-3 group-[.toaster]:animate-in group-[.toaster]:slide-in-from-top-4 group-[.toaster]:fade-in-0 group-[.toaster]:zoom-in-95 group-[.toaster]:duration-300 transition-all ease-out",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-full",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-full",
          closeButton:
            "group-[.toast]:!left-auto group-[.toast]:!right-2 group-[.toast]:!top-2 group-[.toast]:!translate-x-0 group-[.toast]:!translate-y-0 group-[.toast]:!bg-background group-[.toast]:!border-border group-[.toast]:!text-foreground group-[.toast]:!rounded-full hover:group-[.toast]:!bg-muted transition-colors",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
